import DossierContext from '@/dossier/models/DossierContext';
import { BIKE_TYPES } from '@/shared/constants/VehicleType';
import AbstractContext from '@/shared/models/AbstractContext';
import { isPresent } from '@/shared/utils/typescript';
import AxleLocation from '../constants/AxleLocation';
import Axle from './Axle';
import TireContainer from './TireContainer';

export default class TireContext extends AbstractContext {
  public showInfo = false;

  constructor(
    readonly dossierContext: DossierContext,
    public container: TireContainer,
  ) {
    super();
    this.container.sanitize();
  }

  static withDefaultSettings(dossierContext: DossierContext): TireContext {
    const isMotorcycle = isPresent(dossierContext.dossierVehicle.vehicle.type) && BIKE_TYPES.includes(dossierContext.dossierVehicle.vehicle.type);
    const wheelCount = isMotorcycle ? 1 : 2;
    const container = new TireContainer();
    container.axles.push(
      Axle.withPositions(wheelCount, AxleLocation.FRONT, 0),
      Axle.withPositions(wheelCount, AxleLocation.REAR, 0),
    );
    return new TireContext(dossierContext, container);
  }
}